import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { Icon } from "design-react-kit";

import useBreadcrumbs from "use-react-router-breadcrumbs";
import secureLocalStorage from "react-secure-storage";

const Breadcrumbs = ({ page, year }) => {
  const navigate = useNavigate();

  const edit = secureLocalStorage.getItem("edit");

  const routes = [
    { path: "/statistics", breadcrumb: "Report consuntivo" },
    {
      path: "/statistics/details",
      breadcrumb: "Dettaglio",
    },
    { path: "/users", breadcrumb: "Gestione Utenti" },
    { path: "/notificheAI/uploadFiles", breadcrumb: "Carica documenti" },
    { path: "/notificheAI/verification", breadcrumb: "Da verificare" },
    { path: "/notificheAI/verificationf24", breadcrumb: "Da verificare (F24)" },
    { path: "/notificheAI/flows", breadcrumb: "Flussi pronti" },
    { path: "/notificheAI", breadcrumb: "Notifiche AI" },
    {
      path: "/notificheAI/verification/edit/:id",
      breadcrumb: edit ? "Modifica" : "Visualizza",
    },
    {
      path: "/notificheAI/verificationf24/edit/:id/:clientId",
      breadcrumb: "Modifica",
    },
    {
      path: "/notificheAI/flows/notifications",
      breadcrumb: "Notifiche",
    },
    {
      path: "/notificheAI/flows/notifications/:flowId",
      breadcrumb: "Notifiche",
    },
    { path: "/authModule", breadcrumb: "Modulo Autorizzativo" },
    { path: "/authModule/invalidFlows", breadcrumb: "Flussi non validi" },
    { path: "/authModule/flowsArchive", breadcrumb: "Flussi archiviati" },
    {
      path: "/authModule/technicalFlows",
      breadcrumb: "Flussi disponibili (verifica tecnica)",
    },
    {
      path: "/authModule/economicalFlows",
      breadcrumb: "Flussi disponibili (verifica finanziaria)",
    },
    {
      path: "authModule/flowsWithFailedCostCalculation",
      breadcrumb: "Flussi (costo non calcolato)",
    },
    {
      path: "/authModule/technicalFlows/notifications",
      breadcrumb: "Flusso Notifiche",
    },
    {
      path: "/authModule/economicalFlows/notifications",
      breadcrumb: "Flusso Notifiche",
    },
    {
      path: "/authModule/technicalFlows/notifications/:client/:flowId/:flowType",
      breadcrumb: "Flusso Notifiche",
    },
    {
      path: "/authModule/economicalFlows/notifications/:client/:flowId",
      breadcrumb: "Flusso Notifiche",
    },
    {
      path: "/authModule/economicalFlows/notifications/:client/:flowId/:flowType",
      breadcrumb: "Flusso Notifiche",
    },
    {
      path: "/authModule/technicalFlows/notifications/files",
      breadcrumb: "Notifiche Files",
    },
    {
      path: "/authModule/technicalFlows/notifications/files/:client/:id/",
      breadcrumb: "Notifiche Files",
    },
    {
      path: "/authModule/economicalFlows/notifications/files",
      breadcrumb: "Notifiche Files",
    },
    {
      path: "/authModule/economicalFlows/notifications/files/:client/:id/",
      breadcrumb: "Notifiche Files",
    },
    {
      path: "/authModuleConfiguration",
      breadcrumb: "Configurazione Modulo Autorizzativo",
    },
    { path: "/clientConfiguration", breadcrumb: "Configurazione Modulo AI" },
    {
      path: "/externalFlowConfiguration",
      breadcrumb: "Configurazione flussi esterni",
    },
    {
      path: "/clientConfiguration/clientDocumentsConfiguration/:client/:clientId",
      breadcrumb: "Configurazione Documenti",
    },
    {
      path: "/clientConfiguration/clientDocumentsConfiguration",
      breadcrumb: "Configurazione Documenti",
    },
    {
      path: "/clientConfiguration/check/:clientId/:client",
      breadcrumb: "Configurazione Modulo AI - Verifica",
    },
    {
      path: "/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/:client/:clientId/:document/:documentId/:clientDocumentRuleId",
      breadcrumb: "Documento (frasi chiave)",
    },
    {
      path: "/clientConfiguration/clientDocumentsConfiguration/preview/:clientId/:documentTypeId",
      breadcrumb: "Analisi",
    },
    { path: "/", breadcrumb: "Flussi" },
    { path: "/externalFlows", breadcrumb: "Flussi esterni" },
  ];

  const breadcrumb = useBreadcrumbs(routes);
  const location = useLocation();

  const params = useParams();
  const notificationName = secureLocalStorage.getItem(
    "notificationDescription"
  );
  const clientName = params?.client;
  const clientId = params?.clientId;
  const documentType = params?.document;
  const documentTypeId = params?.documentTypeId;
  const clientDocumentRuleId = params?.clientDocumentRuleId;
  const flowId = params?.flowId;
  const notificationId = params?.id;
  const flowName = secureLocalStorage.getItem("flowName");

  return (
    <nav>
      {breadcrumb.map((item) => (
        <Link
          key={item.match.pathname}
          to={
            item.match.pathname !== "/notificheAI" &&
            item.match.pathname !== "/notificheAI/verification/edit" &&
            item.match.pathname !==
              `/notificheAI/flows/notifications/${flowId}` &&
            item.match.pathname !== `/notificheAI/flows/notifications` &&
            item.match.pathname !== "/authModule" &&
            item.match.pathname !==
              "/authModule/technicalFlows/notifications" &&
            item.match.pathname !==
              "/authModule/economicalFlows/notifications" &&
            item.match.pathname !==
              `/authModule/technicalFlows/notifications/${encodeURIComponent(
                clientName
              )}` &&
            item.match.pathname !==
              `/authModule/economicalFlows/notifications/${encodeURIComponent(
                clientName
              )}` &&
            item.match.pathname !==
              `/authModule/technicalFlows/notifications/${encodeURIComponent(
                clientName
              )}/${flowId}` &&
            item.match.pathname !==
              `/authModule/economicalFlows/notifications/${encodeURIComponent(
                clientName
              )}/${flowId}` &&
            item.match.pathname !==
              `/authModule/technicalFlows/notifications/files` &&
            item.match.pathname !==
              `/authModule/economicalFlows/notifications/files` &&
            item.match.pathname !==
              `/authModule/technicalFlows/notifications/files/${encodeURIComponent(
                clientName
              )}` &&
            item.match.pathname !==
              `/authModule/economicalFlows/notifications/files/${encodeURIComponent(
                clientName
              )}` &&
            item.match.pathname !==
              "/clientConfiguration/clientDocumentsConfiguration" &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/preview` &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/preview/${clientId}` &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/preview/${clientId}/${documentTypeId}` &&
            item.match.pathname !==
              "/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration" &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
                clientName
              )}` &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
                clientName
              )}/${clientId}` &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
                clientName
              )}/${clientId}/${encodeURIComponent(documentType)}` &&
            item.match.pathname !==
              `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
                clientName
              )}/${clientId}/${encodeURIComponent(
                documentType
              )}/${clientDocumentRuleId}` &&
            item.match.pathname !== "/notificheAI/verificationf24/edit" &&
            item.match.pathname !==
              `/notificheAI/verificationf24/edit/${notificationId}`
              ? item.match.pathname
              : ""
          }
          className={
            item.match.pathname === location.pathname
              ? "breadcrumb-active"
              : "breadcrumb-not-active"
          }
        >
          {page !== "clientDocumentPhrasesConfiguration" &&
          item.match.pathname !== "/" &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/${encodeURIComponent(
              clientName
            )}` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/preview` &&
          item.match.pathname !== `/clientConfiguration/check` &&
          item.match.pathname !== `/clientConfiguration/check/${clientId}` &&
          item.match.pathname !==
            "/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration" &&
          item.match.pathname !== `/notificheAI/flows/notifications` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
              clientName
            )}` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
              clientName
            )}/${clientId}` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
              clientName
            )}/${clientId}/${encodeURIComponent(documentType)}` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
              clientName
            )}/${clientId}/${encodeURIComponent(
              documentType
            )}/${documentTypeId}` &&
          item.match.pathname !==
            `/clientConfiguration/clientDocumentsConfiguration/clientDocumentsConfiguration/${encodeURIComponent(
              clientName
            )}` &&
          item.match.pathname !== "/notificheAI/verification/edit" &&
          item.match.pathname !== "/notificheAI/verificationf24/edit" &&
          item.match.pathname !==
            `/notificheAI/verificationf24/edit/${notificationId}` &&
          item.match.pathname !== "/authModule/technicalFlows/notifications" &&
          item.match.pathname !== "/authModule/economicalFlows/notifications" &&
          item.match.pathname !==
            `/authModule/technicalFlows/notifications/${encodeURIComponent(
              clientName
            )}` &&
          item.match.pathname !==
            `/authModule/technicalFlows/notifications/${encodeURIComponent(
              clientName
            )}/${flowId}` &&
          item.match.pathname !==
            `/authModule/economicalFlows/notifications/${encodeURIComponent(
              clientName
            )}` &&
          item.match.pathname !==
            `/authModule/economicalFlows/notifications/${encodeURIComponent(
              clientName
            )}/${flowId}`
            ? item.match.pathname === location.pathname
              ? `${item.breadcrumb.props.children} > `
              : `${item.breadcrumb.props.children} / `
            : ""}
          {page === "home" && item.match.pathname === "/" && `Flussi >`}
          {page === "clientDocumentPhrasesConfiguration" &&
          item.match.pathname !== "/" &&
          (item.match.pathname ===
            `/clientConfiguration/clientDocumentsConfiguration` ||
            item.match.pathname === `/clientConfiguration` ||
            item.match.pathname ===
              `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${encodeURIComponent(
                clientName
              )}/${clientId}/${encodeURIComponent(
                documentType
              )}/${documentTypeId}/${clientDocumentRuleId}`)
            ? item.match.pathname === location.pathname
              ? `${item.breadcrumb.props.children} > `
              : `${item.breadcrumb.props.children} / `
            : ""}
        </Link>
      ))}

      <h5>
        {page === "statisticsDetails" && (
          <Icon
            icon="it-arrow-left"
            className="mr-2 return"
            onClick={(e) => {
              navigate("/statistics", {
                state: year,
              });
            }}
          />
        )}
        {(page === "edit" ||
          page === "preview" ||
          page === "check" ||
          page === "clientDocumentsConfiguration" ||
          page === "clientDocumentPhrasesConfiguration" ||
          page === "flowNotificationsAI" ||
          page === "authModuleNotifs" ||
          page === "authModuleNotifFiles" ||
          page === "editF24") && (
          <Icon
            icon="it-arrow-left"
            className="mr-2 return"
            onClick={(e) => {
              navigate(-1);
            }}
          />
        )}
        {page === "clientDocumentsConfiguration" && (
          <span className="fileName">{`${clientName} > `}</span>
        )}
        {page === "clientDocumentPhrasesConfiguration" && (
          <span className="fileName">{`${clientName} > ${documentType} > `}</span>
        )}
        {breadcrumb[breadcrumb.length - 1].breadcrumb.props.children}{" "}
        {page === "edit" && (
          <>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {"> "}
            </span>
            <span className="fileName">{notificationName}</span>
          </>
        )}
        {page === "authModuleNotifFiles" && (
          <>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {"> "}
            </span>
            <span className="fileName">{clientName}</span>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {" > "}
            </span>
            <span className="fileName">{flowName}</span>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {" > "}
            </span>
            <span className="fileName">{notificationName}</span>
          </>
        )}
        {page === "flowNotificationsAI" && (
          <span className="fileName">{` > ${flowName}`}</span>
        )}
        {page === "editF24" && (
          <span
            style={{ fontSize: "16px", verticalAlign: "middle" }}
            className="notificationName"
          >{` > ${notificationName}`}</span>
        )}
        {page === "authModuleNotifs" && (
          <>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {"> "}
            </span>
            <span className="fileName">{clientName}</span>
            <span style={{ fontSize: "16px", verticalAlign: "middle" }}>
              {" > "}
            </span>
            <span className="fileName">{flowName}</span>
          </>
        )}
      </h5>
    </nav>
  );
};

export default Breadcrumbs;
